const ALWAYS_AVAILABLE_CHANNELS = [
  'website',
  'twilio',
  'api',
  'whatsapp',
  'sms',
  'telegram',
  'line',
  'instagram',
  'tiktok',
  'voice',
];

// Whether a channel can be created with the account features and the
// installation config (Meta app ids). Shared by the channel pickers.
export const isChannelAvailable = (
  key,
  enabledFeatures = {},
  config = window.chatwootConfig || {}
) => {
  if (Object.keys(enabledFeatures).length === 0) return false;

  if (key === 'website') return !!enabledFeatures.channel_website;
  if (key === 'facebook') {
    return !!(enabledFeatures.channel_facebook && config.fbAppId);
  }
  if (key === 'email') return !!enabledFeatures.channel_email;
  if (key === 'instagram') {
    return !!(enabledFeatures.channel_instagram && config.instagramAppId);
  }
  if (key === 'tiktok') {
    return !!(enabledFeatures.channel_tiktok && config.tiktokAppId);
  }
  if (key === 'voice' || key === 'whatsapp_call') {
    return !!enabledFeatures.channel_voice;
  }

  return ALWAYS_AVAILABLE_CHANNELS.includes(key);
};
